'use client';

import { forwardRef } from 'react';
import { TextInput as MantineTextInput } from '@mantine/core';
import type { TextInputProps as MantineTextInputProps } from '@mantine/core';

import type { LockedProps } from '../types';

export type TextInputProps = Omit<MantineTextInputProps, LockedProps>;

/**
 * ### TextInput
 *
 * @description
 * Mantine's TextInput minus per-call-site style overrides (see {@link LockedProps}),
 * with a locked label/input/error/description order. For the clearable search field
 * use `SearchInput` from `@highlight-cp/core-ui-compositions`.
 *
 * @example
 * <TextInput />
 */
export const TextInput = forwardRef<HTMLInputElement, TextInputProps>((props, ref) => (
  <MantineTextInput
    {...props}
    ref={ref}
    inputWrapperOrder={['label', 'input', 'error', 'description']}
  />
));
TextInput.displayName = 'TextInput';
